// A central location to manage dialog configurations for dialogs used in user components where the dialogs
// need to be isolated from the component logic with an aim to improve maintainability and reusability.
import { Injectable } from '@angular/core';
import {
    SimpleListOrganizationsComponent
} from "../organizations/simple-list-organizations/simple-list-organizations.component";
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class DialogService {
    
    openOrganizationDialog(
        dialog: MatDialog, 
        selectedOrgId: string, 
        componentContext: string
    ): MatDialogRef<SimpleListOrganizationsComponent> {
        
        const dialogConfig = {
            data: selectedOrgId,
            disableClose: true,
            width: 'auto',
            height: 'auto',
            // Use component context for unique identification
            panelClass: `${componentContext}-org-dialog`,
            hasBackdrop: true,
            backdropClass: `${componentContext}-org-backdrop`,
            // Add unique ID for tracking
            id: `${componentContext}-org-dialog-${Date.now()}`
        };
        return dialog.open(SimpleListOrganizationsComponent, dialogConfig);
    }
}